import { render } from "./ContentGuidelines.vue?vue&type=template&id=6b30a15a"
import script from "./ContentGuidelines.vue?vue&type=script&lang=js"
export * from "./ContentGuidelines.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__